import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Helmet from 'react-helmet';


const RiasecMeaning = props => {
    
     
    useEffect(() => {        
      
    }, []);
       


    return (
        <div className="mb-5 riasec-list">
            <Helmet>
                <title>RIASEC คืออะไร?</title>
                <meta property="og:title"       content={`RIASEC คืออะไร? - Mindsetmaker.co`} />
                <meta property="og:description" content={`ค้นหาตัวตนผ่านมิติอาชีพอย่างครบถ้วนตามทฤษฎีของ Prof. John Holland (RIASEC) ด้วย Task-based Activitie`} />
            </Helmet>
            <div className="px-2 px-md-4 main-detail">
               
                <Row className="px-0" >
                        <Col xs={12}>
                            <h2 class="text-green pb-3 py-md-3 mt-4 text-center">RIASEC คืออะไร?</h2>                   
                            <p className='font-sarabun-bold'>ค้นหาตัวตนผ่านมิติอาชีพอย่างครบถ้วนตามทฤษฎีของ Prof. John Holland (RIASEC) ด้วย Task-based Activitie</p> 
                        </Col>         
                        <Col xs={12}>
                            <h2 class="text-green pb-3 py-md-3 mt-4 text-center">ทฤษฎีของ Holland</h2>          
                            <p className='font-sarabun-bold'>
                                <ul>                                    
                                    <li>ได้รับการยอมรับและถูกนำไปใช้ในการให้คำปรึกษาด้านอาชีพอย่างกว้างขวาง</li>
                                    <li>รับรองโดยงานวิจัยที่ต่อเนื่องกว่า 60 ปี</li>
                                    <li>ถูกนำไปใช้ในโรงเรียน มหาวิทยาลัยและองค์กรทั่วโลก</li>
                                    <li>ใช้โดยกระทรวงแรงงานของสหรัฐอเมริกา</li>
                                    <li>ใช้โดยหน่วยงานรัฐบาลทั่วโลก เช่น ออสเตรเลีย แคนาดา สวิตเซอร์แลนด์ ฯลฯ</li>
                                </ul>
                            </p>          
                        </Col>              
                            
                </Row>
                <Row className="py-2 mt-3">
                    <Col xs={12} md={5} className="">
                        <img src='/images/riasec/riasec_meaning.png' width={'100%'} alt='Riasec Meaning' /> 
                    </Col>
                    <Col xs={12} md={7} className="d-flex">
                        <div className='blue-bg p-3 p-md-5 t-1 m-auto font-sarabun-bold border-radius-125'>
                            <p className='text-indent-18'><span className='text-green'>R:</span> ชอบการลงมือทำจริงชอบกีฬาและกิจกรรมกลางแจ้ง</p>
                            <p className='text-indent-18'><span className='text-green'>I:</span> สนใจในวิทยาศาสตร์และการแสวงหาความรู้แขนงต่างๆ</p>
                            <p className='text-indent-18'><span className='text-green'>A:</span> ชอบช่วยเหลือผู้อื่น อยากเห็นผู้อื่นพัฒนาชอบสร้างความสัมพันธ์ที่ดีกับคนรอบข้าง</p>
                            <p className='text-indent-18'><span className='text-green'>S:</span> มีความคิดสร้างสรรค์มีจินตนาการ เชื่อในสัญชาตญาณของตัวเอง</p>
                            <p className='text-indent-18'><span className='text-green'>E:</span> มีความเป็นผู้นำสามารถโน้มน้าวใจ และมีอิทธิพลต่อการตัดสินใจของผู้อื่น</p>
                            <p className='text-indent-18'><span className='text-green'>C:</span> ชอบจัดระบบข้อมูลตัวเลข มีความเป็นระเบียบสูง</p>
                        </div>    
                    </Col>                                    
                </Row>                
            </div>
        </div>
    )
}


export default RiasecMeaning